import(/* webpackMode: "eager" */ "/app/app/(checkout)/checkout/page.jsx");
